import * as Operations from './operations';
import markingsReducer, { initialMarknigState } from './reducer';
export * from './types';
export { Operations };
export { initialMarknigState };


export default markingsReducer;
